import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FloatingCTA from './components/FloatingCTA';
// import Courses from './components/Courses'; // moved to /courses page
import CourseStructure from './components/CourseStructure';
import CourseCurriculum from './components/CourseCurriculum';
import DesignGraph from './components/DesignGraph';
import SocialProof from './components/SocialProof';
import Testimonials from './components/Testimonials';
import Team from './components/Team';
import Footer from './components/Footer';
import GuidesPage from './pages/GuidesPage';
import GuideDetailPage from './pages/GuideDetailPage';
import BookReaderPage from './pages/BookReaderPage';
import CoursesPage from './pages/CoursesPage';

const BlogSlugRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/guides/${slug}`} replace />;
};

const HomePage = () => (
  <div>
    <Navbar />
    <Hero />
    <DesignGraph />
    <CourseStructure />
    <CourseCurriculum />
    {/* <Courses /> — moved to /courses page */}
    <SocialProof />
    <Testimonials />
    <Team />
    <Footer />
    <FloatingCTA />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/guides"
          element={
            <>
              <Navbar />
              <GuidesPage />
              <Footer />
            </>
          }
        />
        <Route path="/guides/:slug" element={<GuideDetailPage />} />
        <Route path="/blogs" element={<Navigate to="/guides" replace />} />
        <Route path="/blogs/:slug" element={<BlogSlugRedirect />} />
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/book" element={<BookReaderPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
